export const description =
  "Plan France 2030 volet Agriculture : 3e révolution agricole, robotique, serres décarbonées, méthanisation. Subventions et avances remboursables via Bpifrance, FranceAgriMer, ADEME.";
